import autopricingResult from './result';
import { Project } from '~/types/project';

export default function solarContract(project: Project, projectState: any) {
  const { ppaResult, leaseResult } = autopricingResult(project, projectState);
  const { ppaPricing, leasePricing } = project?.savingsAnalysis || {};

  return {
    ppaSolarContract: ppaPricing ? ppaResult : '—',
    leaseSolarContract: leasePricing ? leaseResult : '—'
  };
}